import $ from 'jquery';
import Popover from '../../bootstrap/popover.js';
import { defineJQueryPlugin } from '../../util/plugin.js';
// import mpro from './mpro.init';

export class MpPopover extends Popover {

	constructor(element, config) {
		super(element, config);
		// Attach the instance to the element
		// @ts-ignore
		this._element._popover = this;
	}

	dispose() {
		// Detach the instance from the element
		// @ts-ignore
		this._element._popover = null;
		super.dispose();
	}

	/**
	 * Redefined the jQueryInterface to use our own class
	 *
	 * @param {*} config
	 *
	 * @this {JQuery}
	 */
	static jQueryInterface(config) {
		return this.each(function() {
			const data = MpPopover.getOrCreateInstance(this, config);

			if (typeof config === 'string') {
				if (typeof data[config] === 'undefined') {
					throw new TypeError(`No method named "${config}"`);
				}

				data[config]();
			}
		});
	}
}

const $container = $('div.popover-container');

// So we separate the containers (one on the body (tooltip) and one just below the body (popover))
export const bodyPopover = new MpPopover(document.body, {
	html: true,
	selector: '[data-bs-toggle="popover"]',
	container: $container[0] || document.body,
});

// Close Popovers
mpro.removePopovers = function($container) {

	// Remove bs5 popovers
	for (const element of $('[data-bs-toggle="popover"]', $container)) {
		try {
			// @ts-ignore
			element._popover && element._popover.dispose();
		}
		catch (error) {
			console.warn('Error while trying to dispose popover instance for element (%o): %o', element, error);
		}
	}
};

// We also have to replace the original jQuery plugin interface
defineJQueryPlugin(MpPopover);

export default mpro;
